import { gql } from "@apollo/client";
import { graphql } from "@apollo/client/react/hoc";
import { Menu, Dropdown } from "semantic-ui-react";

import logout from "common/helpers/logout";

const AccountDropdown = ({ data }) => {
  if (data.loading || !data.user) {
    return null;
  }

  return (
    <Menu.Menu position="right" style={{ paddingRight: "1em" }}>
      <Dropdown text={data.user.email} style={{ alignSelf: "center" }}>
        <Dropdown.Menu>
          <Dropdown.Item
            icon="settings"
            text="Account settings"
            as="a"
            href="/users/edit"
            target="_blank"
          />
          <Dropdown.Item
            onClick={logout}
            icon="sign out"
            text="Log out"
            as="a"
          />
        </Dropdown.Menu>
      </Dropdown>
    </Menu.Menu>
  );
};

const UserQueryRaw = gql`
  query CurrentUser {
    user {
      id
      first_name
      last_name
      email
    }
  }
`;
const UserQuery = graphql(UserQueryRaw);

export default UserQuery(AccountDropdown);
